<template>
  <BLayoutExpansionTableAsync
    :value="list"
    v-bind="$attrs"
    :loading="isLoading"
    :readonly="readonly"
    :pagination="pagination"
    title="Варианты заданий"
    type-table="collector-variants"
    name="variants"
    return-object
    @change:pagination="onChangePagination"
    @action:download="onDownloadList"
  >
    <template #top>
      <BListFilter
        v-model="searchForm"
        label="Поиск по варианту"
        :skeleton="isLoading"
        dense
        @change="onChangeDebounced"
      />
    </template>
  </BLayoutExpansionTableAsync>
</template>

<script>
import { downloadLinkByGet } from '@/helpers/downloadBlob'

import BLayoutExpansionTableAsync from '@/components/layouts/BLayoutExpansionTableAsync.vue'

import { DEFAULT_PER_PAGE } from '@/helpers/enums/params'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'
import { KimVariantApi } from '@/api/resources'
import BListFilter from '@/components/forms/BListFilter.vue'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
  count: 0,
}

export default {
  name: 'BasePublicationsVariantsExpansionTable',
  components: { BLayoutExpansionTableAsync, BListFilter },
  props: {
    publication: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    list: [],
    searchForm: {
      search: null,
    },
    pagination: { ...DEFAULT_PARAMS },
  }),
  computed: {
    readonly() {
      return !this.$access(Permissions.edit)
    },
  },
  methods: {
    asyncData() {
      const params = { ...this.pagination }
      this.onGetData(params)
    },
    async onGetData(params) {
      const api = new KimVariantApi()
      try {
        const payload = {
          ...this.pagination,
          ...params,
          publication_id: this.publication.publication_id,
        }
        if (this.searchForm.search && !Number.isNaN(+this.searchForm.search)) {
          payload.original_variant = this.searchForm.search
        }
        const result = await api.getAll(payload)
        this.list = result.data
        this.pagination.count = result.meta.count
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    onChangePagination(options) {
      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData()
    },
    onChangeDebounced() {
      this.onGetData()
    },
    onDownloadList({ sha1_sum }) {
      try {
        const path = `${process.env.VUE_APP_COLLECTOR_API_URL}/api/v1/files/${sha1_sum}/download`
        downloadLinkByGet(
          path,
          false,
          { isNewTab: false },
          { headers: { 'X-Access-Token': process.env.VUE_APP_COLLECTOR_API_TOKEN } },
        )
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
